// CheckoutCancel.jsx
// Stripe redirects here when user clicks "Back" or closes checkout.
// Data is preserved in localStorage — user can retry.

import { useNavigate } from "react-router-dom";

const D = {
  bg: "#0E0F14", card: "#191C26", border: "rgba(255,255,255,0.07)",
  accent: "#6C7EF8", warn: "#F59E0B", warnDim: "rgba(245,158,11,0.1)",
  textPrimary: "#F0F2F7", textSec: "#B0B7CE", textMuted: "#5A607A",
  fontDisplay: "'Plus Jakarta Sans', sans-serif",
  fontBody:    "'DM Sans', sans-serif",
  fontMono:    "'JetBrains Mono', monospace",
};

export default function CheckoutCancel() {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@600;700;800&family=DM+Sans:wght@400;500;600&family=JetBrains+Mono:wght@400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: ${D.bg}; color: ${D.textPrimary}; font-family: ${D.fontBody}; -webkit-font-smoothing: antialiased; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(18px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp 0.5s cubic-bezier(0.22,1,0.36,1) both; }
        .d1 { animation-delay: 0.1s; }
      `}</style>

      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
        <div style={{ width: "100%", maxWidth: 420, textAlign: "center" }}>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 36 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 9,
              background: `linear-gradient(135deg, ${D.accent} 0%, #9B6EF8 100%)`,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: D.fontDisplay, fontWeight: 800, fontSize: 15, color: "white",
            }}>Z</div>
            <span style={{ fontFamily: D.fontDisplay, fontWeight: 700, fontSize: 16, color: D.textPrimary }}>
              zenithpost<span style={{ color: D.accent }}>.ai</span>
            </span>
          </div>

          <div className="fade-up" style={{
            background: D.card, border: `1px solid ${D.border}`, borderRadius: 20,
            padding: "40px 32px", boxShadow: "0 24px 64px rgba(0,0,0,0.4)",
          }}>
            <div style={{
              width: 56, height: 56, borderRadius: "50%",
              background: D.warnDim, border: "1px solid rgba(245,158,11,0.25)",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 24px", fontSize: 24,
            }}>
              ←
            </div>

            <h2 style={{ fontFamily: D.fontDisplay, fontWeight: 700, fontSize: 24, color: D.textPrimary, marginBottom: 12 }}>
              Payment cancelled
            </h2>
            <p style={{ fontSize: 14, color: D.textSec, lineHeight: 1.7, marginBottom: 28 }}>
              No worries — your brand profile is still saved and nothing was charged. You can return to complete your subscription whenever you're ready.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <button
                onClick={() => navigate("/checkout")}
                style={{
                  padding: "13px 0", borderRadius: 11, border: "none", cursor: "pointer",
                  background: `linear-gradient(135deg, ${D.accent} 0%, #8B6EF8 100%)`,
                  color: "white", fontFamily: D.fontBody, fontSize: 14.5, fontWeight: 700,
                  boxShadow: "0 6px 20px rgba(108,126,248,0.3)",
                }}
              >
                Return to checkout
              </button>
              <button
                onClick={() => navigate("/brand-profile")}
                style={{
                  padding: "13px 0", borderRadius: 11, border: `1px solid ${D.border}`, cursor: "pointer",
                  background: "rgba(255,255,255,0.03)", color: D.textSec,
                  fontFamily: D.fontBody, fontSize: 14, fontWeight: 600,
                }}
              >
                Edit brand profile
              </button>
            </div>
          </div>

          <div className="fade-up d1" style={{ marginTop: 20 }}>
            <button
              onClick={() => navigate("/")}
              style={{ background: "none", border: "none", cursor: "pointer", fontFamily: D.fontMono, fontSize: 11, color: D.textMuted }}
            >
              ← Back to zenithpost.ai
            </button>
          </div>
        </div>
      </div>
    </>
  );
}